import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./SidebarFooterIcon.css";

import phone from "./phone-call.svg";
import facebook from "./facebook (1).svg";
import WhatsApp from "./whatsapp.svg";
import Instagram from "./instagram.svg";
import YouTube from "./youtube.svg";
import linkedin from "./linkedin-svgrepo-com.svg";

const SocialMediaIcons = () => {
  const callNow = {
    href: "tel:+919766690774",
    icon: phone,
    tooltip: "Call Now",
    className: "phone",
  };

  const socialLinks = [
    // { href: "tel:+919766690774", icon: phone, tooltip: "Call Now", className: "phone" },
    {
      href: "https://www.facebook.com/people/Shrikrishna-Arogyam/100093267866282/?paipv=0&eav=AfZ_PEZMuFt_65oNZkSi8nd39FZaPVzEBXe9C6ed62cTXo2bfRYyy5vFC6FfxnjWRF4",
      icon: facebook,
      tooltip: "Facebook",
      className: "facebook",
    },
    {
      href: "https://wa.me/919766690774?text=Hello",
      icon: WhatsApp,
      tooltip: "WhatsApp",
      className: "whatsapp",
    },
    {
      href: "https://www.instagram.com/shri_krishnaarogyam/",
      icon: Instagram,
      tooltip: "Instagram",
      className: "instagram",
    },
    {
      href: "https://www.youtube.com/channel/UCsUN2f53Zvw2UtaIOirzowg",
      icon: YouTube,
      tooltip: "YouTube",
      className: "youtube",
    },
    {
      href: "https://www.linkedin.com/in/shrikrishna-arogyam-massage-therapy-and-massage-home-service-55091127a/",
      icon: linkedin,
      tooltip: "LinkedIn",
      className: "linkedin",
    },
  ];

  return (
    <div className="navbar-social-icons">
      {/* Call Now Icon (Aligned Left) */}
      <div className="call-now-container">
        <OverlayTrigger
          trigger="hover"
          placement="bottom"
          overlay={<Tooltip id="tooltip-call">{callNow.tooltip}</Tooltip>}
        >
          <a
            href={callNow.href}
            className={`icon ${callNow.className}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={callNow.icon} alt="Call Now" width="30" />
          </a>
        </OverlayTrigger>
      </div>

      {/* Other Social Media Icons (Aligned Right) */}
      <div className="social-icons-container">
        {socialLinks.map((item, index) => (
          <OverlayTrigger
            trigger="hover"
            key={index}
            placement="bottom"
            overlay={<Tooltip id={`tooltip-${index}`}>{item.tooltip}</Tooltip>}
          >
            <a
              href={item.href}
              className={`icon ${item.className}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={item.icon} alt={item.tooltip} width="30" />
            </a>
          </OverlayTrigger>
        ))}
      </div>
    </div>
  );
};

export default SocialMediaIcons;
